/**
 * BUILDER WIZARD - list data
 *
 * @param {String} type - card is sector or producy
 * @param {Objecy} cityOrProduct -  city of product payload
 */
export const builderListData = (type, cityOrProduct, price, description, next, cityID = 0, tourId = "", reservations = null) => {
  return {
    name: cityOrProduct.name,
    next: next ? next : cityOrProduct.name,
    type: type,
    city_id: cityID,
    tour_id: tourId,
    price: price,
    description: description,
    images:(type === 'sector') ? cityOrProduct.images : null,
    media:(type === 'product') ? cityOrProduct.media : null,
    reservations:reservations
  }
}

/**
 * BUILDER WIZARD - reservations data
 *
 * @param {Number} startCityId - start city id
 * @param {Number} endCityId -  end city id
 */
export const reservationData = (startCityId, endCityId) => {
  return {
    "date_for": null,
    "start_city_id": startCityId,
    "end_city_id": endCityId,
    "price": 0
  }
}



// WEBPACK FOOTER //
// ./src/helpers/builderHelper.js